import {useQueryClient} from '@tanstack/react-query'
import {useCallback} from 'react'
import {createQuery} from 'react-query-kit'

import {apiGetCustomTemplates} from '../api/memex/api-get-custom-templates'
import type {GetCustomTemplatesResponse} from '../api/memex/contracts'

export const useOrganizationTemplates = createQuery<GetCustomTemplatesResponse, void>({
  primaryKey: 'org-templates',
  queryFn: () => apiGetCustomTemplates(),
})

export const usePrefetchOrgTemplates = () => {
  const client = useQueryClient()
  return useCallback(
    () =>
      client.prefetchQuery({
        queryKey: useOrganizationTemplates.getKey(),
        queryFn: useOrganizationTemplates.queryFn,
      }),
    [client],
  )
}
